import styles from './DeleteWorkplace.module.css';
import Button from '../../Button/Button';
import { getAllWorkplacesUrl } from '../../../helpers/constants';
import { useState } from 'react';
import useApi from '../../../hooks/useApi.hook';


export function DeleteWorkplace({ workplace, setDeleteModalOpen, setRefreshKey }) {
	const [error, setError] = useState(undefined);

	const api = useApi();
	const deleteWorkplace = async (id) => {
		try {
			await api.delete(`${getAllWorkplacesUrl}${id}`);
			setDeleteModalOpen(false);
			setRefreshKey((prev) => prev + 1);
		} catch (e) {
			setError(
				e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка'
			);
		}
	};

	return (
		<div className={styles['help']}>
			<div className={styles['content']}>
				<div className={styles['title']}>
					<p>Вы действительно хотите удалить рабочее место:</p>
					<p className={styles.workplace_bold}>
						{workplace.external_id} — {workplace.position}
					</p>
					<p className={styles.warning}>
						Вместе с ним будут удалены привязанные вредные факторы и компенсации.
					</p>
				</div>
			</div>
			{error && <div className={styles['error']}>{error}</div>}
			<div className={styles['button']}>
				<Button onClick={() => deleteWorkplace(workplace.id)}>
					Да, удалить
				</Button>
			</div>
		</div>
	);
}